















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const login = namespace("login");

@Component
export default class ChangePasswordSuccess extends Vue {
  @login.Action logout;
  async toLogin() {
    this.$router.push({ name: "Login" });
  }
}
